import { assignInlineVars } from '@vanilla-extract/dynamic'
import { bar, container, varDuration, varStartProgress } from './index.css'

export const CountdownBar = (props: {
  seconds: number
  fullSeconds?: number
}) => {
  const startProgress = props.fullSeconds
    ? props.seconds / props.fullSeconds
    : 1

  return (
    <div className={container}>
      <div
        className={bar}
        style={assignInlineVars({
          [varDuration]: `${props.seconds}s`,
          [varStartProgress]: String(startProgress),
        })}
      />
    </div>
  )
}
